import React from "react";

/**
 *
 * @param code ex) 403, 404
 * @param title ex) Oops! Not Found ;(
 * @param message ex) 존재하지 않는 페이지 입니다
 * @returns {JSX.Element}
 * @constructor
 */
function ErrorPage({code, title, message}) {
  return (
    <div className="error--area-wrapper">
      <div className="error--area">
        <span className="code">{code}</span>
        <h4 className="title">{title}</h4>
        <p className="message">{message}</p>
      </div>
    </div>
  );
}

export default ErrorPage;
